module.exports = __webpack_public_path__ + "img/bluesky3100_07.e087f55c.jpg";